import { CanvasSettings, getCanvas, ApplyCanvasSettings } from "../../../../components/Canvas/Canvas";
import { GGlowSpriteRender } from "../../../backgroundScene";
import { GAudioEngine } from "../../../core/audioEngine";
import {
    GTime,
    MathClamp,
    MathImpulse,
    MathLerp,
    MathMapToRange,
    MathMapToRangeClamped,
    MathSmoothstep,
} from "../../../core/utils";
import { RCombinerPass } from "../../../postprocess";
import { GPostProcessPasses } from "../../../renderingMain";
import { GSceneDesc, SceneBase } from "../../scene";
import { GHallwaySceneCSS } from "./hallwayCSS";
import { PayneSceneHallway } from "./hallwayMain";

const QustionStateCamStart = 90.5 + Math.random() * 4.0;
const TVStateCamStart = 145.0;
const bEnableScript = true;

export function HallwayUpdateMain(gl: WebGL2RenderingContext, scene: PayneSceneHallway) {
    const buf = SceneBase.UniformBuffer.Params;

    if (!bEnableScript) {
    } else {
        //sound
        {
            const audioContext = GAudioEngine.Instance!.Context;
            if (audioContext) {
                if (scene.EHallwaySceneState <= 1) {
                    scene.SoundIntroPad.Play(audioContext, true);

                    scene.SoundOceanWater.Play(audioContext, true);
                    const oceanLoud = MathMapToRangeClamped(
                        GSceneDesc.Camera.Position.z,
                        0.0,
                        QustionStateCamStart,
                        0.0,
                        1.0,
                    );
                    if (scene.SoundOceanWater.Gain) {
                        scene.SoundOceanWater.Gain.gain.value = 0.5 * oceanLoud * oceanLoud;
                        if (scene.bGuiltStageRunning) {
                            scene.SoundOceanWater.Gain.gain.value = 0.0;
                        }
                    }
                }
            }
        }

        //lower light intensity in the hallway
        if (GSceneDesc.Camera.Position.z > 80) {
            const t = MathMapToRange(GSceneDesc.Camera.Position.z, 80, 90, 1.0, 0.5);
            buf.LightIntensity1.x = 22.0 * t;
        }

        if (GSceneDesc.Camera.Position.z > 30 && scene.EHallwaySceneState < 2) {
            GSceneDesc.Camera.ZoomScale = Math.max(2.0, GSceneDesc.Camera.ZoomScale - GTime.Delta * 0.1);
        }

        if (scene.EHallwaySceneState < 0) {
            if (CanvasSettings.Brightness < 0.4) {
                CanvasSettings.Brightness = Math.min(0.4, CanvasSettings.Brightness + GTime.Delta * 0.2);
                ApplyCanvasSettings(getCanvas());
            }
            if (GHallwaySceneCSS.setCurFps) {
                GHallwaySceneCSS.setCurFps(Math.floor(GTime.FPSAvrg));
            }
        }

        if (scene.EHallwaySceneState == 0) {
            GTime.DeltaTimeScale = 1.0;

            const impulseMaxDur = 0.1;
            if (scene.CameraTransitionParam < impulseMaxDur) {
                const t = MathMapToRange(scene.CameraTransitionParam, 0.0, impulseMaxDur, 0.0, 2.0);
                //RCombinerPass.FisheyeParam = MathImpulse(t, 2.0) * 1.3;
                RCombinerPass.FisheyeParam = MathImpulse(t, 2.0) * -0.05;
            } else if (scene.CameraTransitionParam < impulseMaxDur + 0.2) {
                RCombinerPass.FisheyeParam = 0.0;
            }

            // eslint-disable-next-line prefer-const
            let camPosT = MathClamp(scene.CameraTransitionParam, 0.0, 1.0);
            //if (camPosT >= 0.5)
            {
                camPosT = MathSmoothstep(0.0, 1.0, camPosT);
            }

            if (CanvasSettings.Brightness < 1.49) {
                CanvasSettings.Brightness = Math.min(1.5, CanvasSettings.Brightness + GTime.Delta);
                ApplyCanvasSettings(getCanvas());
            }

            const camStartPos = 0.0;
            const camEndPos = QustionStateCamStart;
            GSceneDesc.Camera.Position.z = MathLerp(camStartPos, camEndPos, camPosT);
            scene.CameraTransitionParam += GTime.DeltaSmooth * 0.03;

            if (scene.CameraTransitionParam > 0.95) {
                GHallwaySceneCSS.questionTextSetVisible(true);
            }
            if (scene.CameraTransitionParam > 1.0) {
                //swtich to next state
                scene.CameraTransitionParam = 0.0;
                scene.EHallwaySceneState = 1;

                if (scene.bCustomEventFlag == 0) {
                    scene.bCustomEventFlag = 1;
                }
            }
        } else if (scene.EHallwaySceneState == 1) {
            //RCombinerPass.Exposure = Math.min(1.2, RCombinerPass.Exposure + GTime.Delta * 0.5);
            const desBright = 2.0;
            if (CanvasSettings.Brightness < desBright) {
                CanvasSettings.Brightness = Math.min(desBright, CanvasSettings.Brightness + GTime.Delta * 0.5);
                const canvas = getCanvas();
                ApplyCanvasSettings(canvas);
            }
            buf.AmbientLight.x = Math.max(0.0, buf.AmbientLight.x - GTime.Delta * 0.1);
        } else if (scene.EHallwaySceneState == 2) {
            let camPosT = MathClamp(scene.CameraTransitionParam, 0.0, 1.0);
            if (camPosT >= 0.5) {
                camPosT = MathSmoothstep(0.0, 1.0, camPosT);
            }
            const camStartPos = QustionStateCamStart;
            const camEndPos = TVStateCamStart;
            GSceneDesc.Camera.Position.z = MathLerp(camStartPos, camEndPos, camPosT);
            scene.CameraTransitionParam += GTime.DeltaSmooth * 0.03;

            if (scene.CameraTransitionParam > 0.1) {
                GHallwaySceneCSS.setNorseSubVisibility(true);
            }
            if (scene.CameraTransitionParam > 0.27) {
                GHallwaySceneCSS.setNorseSubVisibility(false);
            }
            if (scene.CameraTransitionParam > 0.3) {
                GHallwaySceneCSS.setNorseSubVisibility(true);
                GHallwaySceneCSS.setNorseSubQuoteIndex(1);
            }
            if (scene.CameraTransitionParam > 0.5) {
                GHallwaySceneCSS.setNorseSubVisibility(false);
            }
            if (scene.CameraTransitionParam > 1.0) {
                scene.EHallwaySceneState = 3;
            }

            if (scene.CameraTransitionParam > 0.0) {
                GPostProcessPasses!.Bloom!.Threshold = Math.max(
                    0.0,
                    GPostProcessPasses!.Bloom!.Threshold - GTime.Delta * 0.1 * 0.5,
                );
            }

            if (scene.CameraTransitionParamHeight < 1.0) {
                let camPosTHeight = MathClamp(scene.CameraTransitionParamHeight, 0.0, 1.0);
                camPosTHeight = MathSmoothstep(0.0, 1.0, camPosTHeight);
                GSceneDesc.Camera.Position.y = MathLerp(2.5, -3.25, camPosTHeight);
                scene.CameraTransitionParamHeight += GTime.DeltaSmooth * 0.1;
            }

            if (GSceneDesc.Camera.Position.z > 120) {
                let camPosTHeight = MathClamp(scene.CameraTransitionParamHeight2, 0.0, 1.0);
                if (camPosTHeight >= 0.0) {
                    camPosTHeight = MathSmoothstep(0.0, 1.0, camPosTHeight);
                }
                GSceneDesc.Camera.Position.y = MathLerp(-3.25, -16.5, camPosTHeight);
                const dropSccale = GSceneDesc.Camera.Position.y < -5.0 ? 0.2 : 0.5;
                scene.CameraTransitionParamHeight2 += GTime.DeltaSmooth * dropSccale;
            }

            if (GSceneDesc.Camera.Position.z > 142.5) {
                GHallwaySceneCSS.setTVSubVisibility(false);
            } else if (GSceneDesc.Camera.Position.y < -16.25) {
                GHallwaySceneCSS.setTVSubVisibility(true);
            }

            const zoomOutStart = 0.995;
            if (scene.CameraTransitionParam > zoomOutStart) {
                const t = MathMapToRangeClamped(scene.CameraTransitionParam, zoomOutStart, 1.0, 0.0, 1.0);
                GSceneDesc.Camera.ZoomScale = MathLerp(2.0, 1.4, t);
            }

            if (scene.CameraTransitionParam > 0.99) {
                const sweepSound = scene.SoundSlowMotionEnd;
                const audioContext = GAudioEngine.Instance!.Context;
                if (!sweepSound.bIsPlaying && audioContext) {
                    sweepSound.Play(audioContext);
                }
            }
            const LoudOutStart = 0.85;
            if (scene.CameraTransitionParam > LoudOutStart) {
                const t = MathMapToRangeClamped(scene.CameraTransitionParam, LoudOutStart, 1.0, 0.0, 1.0);

                if (scene.SoundPyramid.bIsPlaying) {
                    scene.SoundPyramid.Gain!.gain.value = scene.SoundPyramidInitialGain + t * 3.0;
                }
            }
        } else if (scene.EHallwaySceneState == 3) {
            scene.bSceneFinished = true;

            //scene.SoundPyramid.Gain!.gain.value = 0.0;
            //scene.SoundPyramid.Stop();
        }

        if (scene.bPyramidTwistEnabled) {
            scene.PyramidTwistAcceleration += GTime.Delta * 0.4;
            scene.PyramidTwistAcceleration2 += GTime.Delta * 0.1;
            buf.PyramidParams.x += GTime.Delta * scene.PyramidTwistAcceleration2;
            buf.PyramidParams.y += GTime.Delta * scene.PyramidTwistAcceleration;
            buf.PyramidParams.z = Math.max(0, buf.PyramidParams.z - GTime.Delta);

            const lfo = Math.sin(-Math.PI * 0.3 + scene.PyramidParamsBrightness * 1.7 /* * 1.36 */) * 0.5 + 0.5;

            //GAudioEngine.Instance!.Filter!.frequency.value = 1600 * lfo;

            buf.PyramidBrightness.x = 0.2 + scene.PyramidParamsMinBrightness + lfo * 7.0;
            scene.PyramidParamsBrightness += GTime.Delta;
            //scene.PyramidParamsMinBrightness = Math.min(0.75, scene.PyramidParamsMinBrightness + GTime.Delta * 0.075);
        }

        if (scene.EHallwaySceneState >= 0) {
            const start = 0.0;
            const length = QustionStateCamStart - start;
            const numQuotes = 5;
            const period = length / numQuotes;
            const z = GSceneDesc.Camera.Position.z;
            if (z > start) {
                GHallwaySceneCSS.subtitleTextSetVisible(true);
                for (let i = 4; i >= 0; i--) {
                    const l = start + i * period;

                    if (z > l) {
                        GHallwaySceneCSS.setOceanSubQuoteIndex(i);
                        break;
                    }
                }
            }
        }
    }
}

function TransitionToInitialState(scene: PayneSceneHallway) {
    if (bEnableScript) {
        //GHallwaySceneCSS.setVisibilityMain(true);
        scene.EHallwaySceneState = -1;

        //GTime.DeltaTimeScale = 0.4;

        GHallwaySceneCSS.setStartButtonVis(true);

        GSceneDesc.Camera.Position.y = 2.5;
        GSceneDesc.Camera.Position.z = 0.0;
    }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function TransitionToQuestionState(scene: PayneSceneHallway) {
    scene.EHallwaySceneState = 1;

    GHallwaySceneCSS.subtitleTextSetVisible(true);
    GHallwaySceneCSS.setOceanSubQuoteIndex(4);

    GHallwaySceneCSS.questionTextSetVisible(true);

    GSceneDesc.Camera.Position.z = QustionStateCamStart;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function TransitionToTVState(scene: PayneSceneHallway) {
    scene.EHallwaySceneState = 2;

    GHallwaySceneCSS.subtitleTextSetVisible(false);
    GHallwaySceneCSS.setOceanSubQuoteIndex(4);

    GHallwaySceneCSS.questionTextSetVisible(false);

    GSceneDesc.Camera.Position.z = TVStateCamStart;
    GSceneDesc.Camera.Position.y = -16.5;

    GPostProcessPasses!.Bloom!.Threshold = 0.0;

    GSceneDesc.Camera.ZoomScale = 2.0;

    scene.bPyramidTwistEnabled = true;
}

export function TransitionSceneToHallway(gl: WebGL2RenderingContext, scene: PayneSceneHallway) {
    TransitionToInitialState(scene);

    if (!bEnableScript) {
        GSceneDesc.Camera.Position.z = 105.0;
        GSceneDesc.Camera.Position.y = -4.64;
        //GSceneDesc.Camera.Position.z = 2.0;
    }

    GSceneDesc.Camera.ZoomScale = 3.0;

    //Desc
    {
        RCombinerPass.BloomStrength = 1.0;
        GPostProcessPasses.Bloom!.Threshold = 0.4;
        GPostProcessPasses.Bloom!.PreBrightness = 1.0;

        {
            CanvasSettings.Brightness = 1.5;
            if (bEnableScript) CanvasSettings.Brightness = 0.0;
            //CanvasSettings.Contrast = 0.995;
            const canvas = getCanvas();
            ApplyCanvasSettings(canvas);

            RCombinerPass.Exposure = 1.0;
            RCombinerPass.ColorContrast = 1.0;
        }

        //RCombinerPass.DispersionOffsetScale = 1.0;

        RCombinerPass.LensFlareScale = 0.5;

        const buf = SceneBase.UniformBuffer.Params;
        buf.AmbientLight.x = 0.35;

        buf.LightIntensity1.x = 22.0;

        GGlowSpriteRender.GInstance!.bEnabled = false;
    }

    //TransitionToQuestionState(scene);
    //TransitionToTVState(scene);
}
